import { genreLabel } from "../lib/api";
import { ShoppingBag } from "lucide-react";

export const BookCard = ({ book, index = 0, onClick }) => {
  return (
    <article
      data-testid={`book-card-${book.id}`}
      onClick={onClick}
      className={`group fade-in-up ${onClick ? "cursor-pointer" : ""}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="aspect-[2/3] overflow-hidden bg-[#F4F1EA] mb-5 relative">
        <img
          src={book.cover_url}
          alt={book.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {book.is_new && (
          <span className="absolute top-3 left-3 bg-[#9E4735] text-[#FAF9F6] text-[10px] tracking-[0.2em] uppercase font-body px-3 py-1">
            Nouveau
          </span>
        )}
      </div>
      <p className="text-[10px] tracking-[0.2em] uppercase font-body text-[#9E4735] mb-2">
        {genreLabel(book.genre)}
        {book.collection && <span className="text-[#757575] normal-case tracking-normal"> · {book.collection}</span>}
      </p>
      <h3 className="font-serif text-xl text-[#1A1A1A] leading-tight mb-1 group-hover:text-[#2C402E] transition-colors">
        {book.title}
      </h3>
      <p className="text-sm font-body text-[#4A4A4A]">{book.author}</p>
      <div className="flex items-center justify-between mt-3">
        {book.price ? (
          <p className="text-sm font-mono text-[#757575]">{book.price.toFixed(2)} €</p>
        ) : <span />}
        {book.amazon_url ? (
          <a
            href={book.amazon_url}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
            data-testid={`buy-${book.id}`}
            className="inline-flex items-center gap-1.5 text-xs tracking-wide font-body text-[#2C402E] hover:text-[#9E4735] transition-colors"
          >
            <ShoppingBag size={13} />
            Acheter
          </a>
        ) : (
          <a
            href={`mailto:challengeslitteraires.editions@gmail.com?subject=${encodeURIComponent("Commande — " + book.title)}&body=${encodeURIComponent("Bonjour,\n\nJe souhaite commander l'ouvrage « " + book.title + " » de " + book.author + ".\n\nMerci de me communiquer les modalités d'achat.\n\nCordialement,")}`}
            onClick={(e) => e.stopPropagation()}
            data-testid={`order-${book.id}`}
            className="inline-flex items-center gap-1.5 text-xs tracking-wide font-body text-[#2C402E] hover:text-[#9E4735] transition-colors"
          >
            <ShoppingBag size={13} />
            Commander
          </a>
        )}
      </div>
    </article>
  );
};
